<template>
    <div class="header-small">
        <wrapper>
            <div class="header-top d-flex flex-row justify-content-between align-items-md-center px-4 py-4 py-md-0">
                <b-navbar-brand href="/" class="logo">
                    <img src="/src/assets/logo.svg" class="d-inline-block align-top" alt="Trimm">
                </b-navbar-brand>
                <social-network />
            </div>
        </wrapper>
    </div>
</template>

<script>
    import Wrapper from '@/components/common/wrapper.vue';
    import SocialNetwork from '@/components/common/buttons/social-network.vue';

    export default {
        name: 'stripped-header',

        components: {
            'wrapper': Wrapper,
            'social-network': SocialNetwork
        }
    }
</script>
